/**
 * Hook pour vérifier la santé du service Analytics
 */

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import * as analyticsService from '../services/analytics.service';

export const analyticsHealthKeys = {
  all: ['analytics', 'health'] as const,
  health: () => [...analyticsHealthKeys.all] as const,
};

export function useAnalyticsHealth(
  options?: Omit<
    UseQueryOptions<{
      status: string;
      service: string;
      version: string;
      database: string;
    }>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: analyticsHealthKeys.health(),
    queryFn: () => analyticsService.checkAnalyticsHealth(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  });
}
